import React, { Component } from 'react';
import { LoadingSpinnerPage } from '../../../components/atomic/Loaders/LoadingSpinner';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Body from './Body';
import { getResources } from '../../../modules/Resource';
import { setForm } from '../../../modules/ProgramForm';

class ProgramsCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentProgram: null,
      isLoading: true,
    };
  }

  async componentDidMount() {
    const { programData } = this.props;
    this.setState({
      currentProgram: programData,
      isLoading: false,
    });
  }

  submitForm = form => {
    this.props.setForm(form);
  }

  render() {
    const { currentProgram, isLoading } = this.state;

    return isLoading ? (
      <LoadingSpinnerPage />
    ) : (
      <Body initialValues={currentProgram} submit={this.submitForm} />
    )
  }
}

ProgramsCreate.propTypes = {
  
};

ProgramsCreate.defaultProps = {
  
};


function mapStateToProps(state) {
  return {
    resourceState: state.resourceState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getResources: getResources,
    setForm: setForm,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgramsCreate);

